<template>
  <div
      class="pagination-wrap d-flex flex-column align-items-center justify-content-center mt-3"
      style="row-gap: 8px;">
    <ul class="pagination mb-0">
      <li class="page-item">
        <button
            type="button"
            class="page-link"
            @click="onClickFirstPage"
            :disabled="isInFirstPage"
            aria-label="Go to first page">
        {{ '<<' }}
        </button>
      </li>

      <li class="page-item">
        <button
            type="button"
            class="page-link"
            @click="onClickPreviousPage"
            :disabled="isInFirstPage"
            aria-label="Go to previous page">
          {{ '<' }}
        </button>
      </li>

      <li v-for="(page, index) in pages" :key="index" class="page-item">
        <button
            type="button"
            class="page-link"
            @click="onClickPage(page.name)"
            :disabled="page.isDisabled"
            :class="{ active: isPageActive(page.name) }"
            :aria-label="`Go to page number ${page.name}`">
          {{ page.name }}
        </button>
      </li>

      <li class="page-item">
        <button
            type="button"
            class="page-link"
            @click="onClickNextPage"
            :disabled="isInLastPage"
            aria-label="Go to next page">
          >
        </button>
      </li>

      <li class="page-item">
        <button
            type="button"
            class="page-link"
            @click="onClickLastPage"
            :disabled="isInLastPage"
            aria-label="Go to last page">
          >>
        </button>
      </li>
    </ul>

    <div
        v-if="showInfo"
        class="pagination-info"
        style="font-size: 13px; color: #475569; font-weight: 500; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0;">
      Zeige {{ startEntry }} bis {{ endEntry }} von {{ totalItems }} Einträgen
    </div>
  </div>
  </template>

  <script>
  export default {
    props: {
      maxVisibleButtons: {
        type: Number,
        required: false,
        default: 5,
      },
      totalPages: {
        type: Number,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
      totalItems: {
        type: Number,
        required: false,
        default: null,
      },
      perPage: {
        type: Number,
        required: false,
        default: null,
      },
    },
    computed: {
      showInfo() {
        return this.totalItems !== null && this.perPage !== null;
      },
      startEntry() {
        if (!this.showInfo || this.totalItems === 0) {
          return 0;
        }
        return (this.currentPage - 1) * this.perPage + 1;
      },
      endEntry() {
        if (!this.showInfo) {
          return 0;
        }
        return Math.min(this.currentPage * this.perPage, this.totalItems);
      },
      startPage() {
        // If total pages is less than or equal to maxVisibleButtons, start at 1
        if (this.totalPages <= this.maxVisibleButtons) {
          return 1;
        }

        // Calculate the start page
        let start = this.currentPage - Math.floor(this.maxVisibleButtons / 2);
        // Ensure start does not go below 1
        if (start < 1) {
          start = 1;
        }
        // Ensure the range does not exceed total pages
        if (start + this.maxVisibleButtons - 1 > this.totalPages) {
          start = this.totalPages - this.maxVisibleButtons + 1;
        }
        // Return the start page
        return Math.max(start, 1);
      },
      endPage() {
        // If total pages is less than or equal to maxVisibleButtons, show all pages
        if (this.totalPages <= this.maxVisibleButtons) {
          return this.totalPages;
        }

        // Calculate the end page
        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
      },
      pages() {
        const range = [];
        for (let i = this.startPage; i <= this.endPage; i += 1) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage,
          });
        }
        return range;
      },
      isInFirstPage() {
        return this.currentPage === 1;
      },
      isInLastPage() {
        return this.currentPage === this.totalPages;
      },
    },
    methods: {
      onClickFirstPage() {
        this.$emit('pagechanged', 1);
      },
      onClickPreviousPage() {
        this.$emit('pagechanged', this.currentPage - 1);
      },
      onClickPage(page) {
        this.$emit('pagechanged', page);
      },
      onClickNextPage() {
        this.$emit('pagechanged', this.currentPage + 1);
      },
      onClickLastPage() {
        this.$emit('pagechanged', this.totalPages);
      },
      isPageActive(page) {
        return this.currentPage === page;
      },
    },
  };
  </script>

  <style>
  </style>






<!--computed: {-->
<!--startPage() {-->
<!--if (this.currentPage === 1) {-->
<!--return 1;-->
<!--}-->

<!--if (this.currentPage === this.totalPages) {-->
<!--return this.totalPages - this.maxVisibleButtons + 1;-->
<!--}-->

<!--return this.currentPage - 1;-->
<!--},-->
<!--endPage() {-->
<!--return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);-->
<!--},-->
<!--pages() {-->
<!--const range = [];-->

<!--for (let i = this.startPage === 0 ? 1 : this.startPage; i <= this.endPage; i += 1) {-->
<!--range.push({-->
<!--name: i,-->
<!--isDisabled: i === this.currentPage,-->
<!--});-->
<!--}-->

<!--return range;-->
<!--},-->
<!--isInFirstPage() {-->
<!--return this.currentPage === 1;-->
<!--},-->
<!--isInLastPage() {-->
<!--return this.currentPage === this.totalPages;-->
<!--},-->
<!--},-->